<template>
  <div class="muit-home">
    <div class="button-section">
      <button class="btn primary-btn" @click="goToTest">进入测评</button>
      <button class="btn secondary-btn" @click="goToResult">
        查看测评结果
      </button>
    </div>
  </div>
</template>


<script>
export default {
  name: "MUITHome",
  methods: {
    goBack() {
      this.$router.push("/");
    },
    goToTest() {
      this.$router.push("/muit-action");
    },
    goToResult() {
      const openid =
        localStorage.getItem("openId") || localStorage.getItem("openid") || "";
      if (openid) {
        this.$router.push({
          path: "/muit-result",
          query: { openid: openid, wjId: "3" },
        });
      } else {
        this.$message.warning("暂无微信登录信息，请先完成登录");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.muit-home {
  height: 100vh;
  background: url("~@/assets/images/muit-home-bg.png") no-repeat center center;
  background-size: cover;
  padding: 20px;
  position: relative;
}

/* 导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 10px 0;
}

.back-icon {
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo区域 */
.logo-section {
  margin-bottom: 30px;
}

.logos {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #666;
  background: rgba(255, 255, 255, 0.6);
  padding: 8px 12px;
  border-radius: 20px;
}

.logo-icon {
  font-size: 18px;
  color: #5cb85c;
}

.logo-divider {
  font-size: 16px;
  color: #999;
}

/* 引号 */
.quote-mark {
  font-size: 60px;
  color: rgba(92, 184, 92, 0.3);
  line-height: 1;
  margin-bottom: 10px;
  font-family: Georgia, serif;
}

/* 标题 */
.main-title {
  font-size: 36px;
  font-weight: 700;
  color: #4a9b4a;
  margin-bottom: 40px;
  letter-spacing: 2px;
}

.highlight {
  position: relative;
}

.highlight::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, #ffd93d, #ffb800);
  border-radius: 4px;
  z-index: -1;
}

/* 图标区域 */
.image-section {
  width: 200px;
  height: 200px;
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.check-icon {
  position: relative;
  width: 150px;
  height: 150px;
}

.check-board {
  width: 120px;
  height: 140px;
  background: linear-gradient(135deg, #a8e6a3 0%, #7dd87d 100%);
  border-radius: 15px;
  position: absolute;
  top: 0;
  left: 15px;
  box-shadow: 0 10px 30px rgba(92, 184, 92, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(-5deg);
}

.check-board::before {
  content: "";
  position: absolute;
  width: 110px;
  height: 130px;
  background: linear-gradient(135deg, #c8f0c8 0%, #a8e6a3 100%);
  border-radius: 12px;
  top: 5px;
  left: 5px;
}

.check-lines {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.check-lines .line {
  width: 60px;
  height: 4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 2px;
}

.check-arrow {
  position: absolute;
  width: 60px;
  height: 25px;
  background: linear-gradient(90deg, #ffd93d, #ffb800);
  border-radius: 5px;
  bottom: 20px;
  right: -20px;
  z-index: 3;
  transform: rotate(15deg);
}

.check-arrow::after {
  content: "";
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  border: 12px solid transparent;
  border-left: 20px solid #ffb800;
}

/* 按钮区域 */
.button-section {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 300px;
}

.btn {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.primary-btn {
  background: linear-gradient(135deg, #7dd87d 0%, #5cb85c 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(92, 184, 92, 0.4);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(92, 184, 92, 0.5);
}

.secondary-btn {
  background: #fff;
  color: #666;
  border: 1px solid #e0e0e0;
}

.secondary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
</style>
